import state from './moduleSubscriptionTiersState.js';
import mutations from './moduleSubscriptionTiersMutations.js';
import actions from './moduleSubscriptionTiersActions.js';
import getters from './moduleSubscriptionTiersGetters.js';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

